import { css, Theme } from "@emotion/react"

export const buttonContent = (theme: Theme) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${theme.spacing(1)};
`
